import type { IdeaCategoryEmbed } from '@cult/schemas';
import { RoundTag } from '../RoundTag/RoundTag';

type Props = {
  category: Pick<IdeaCategoryEmbed, 'name' | 'color'>;
};

export const CategoryTag = ({ category }: Props) => <RoundTag label={category.name} color={category.color} />;
